import { USER_STATUS } from '../user/user.interface';
import type { User } from '../user/user.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class UserFactory extends ObjectFactory<User> {
  protected getDefaults(): User {
    return {
      ...baseDocumentFactory.build(),
      canBeReinvited: true,
      email: 'test@example.com',
      firstName: 'Test',
      lastActive: null,
      lastName: 'User',
      phone: null,
      roles: ['TENANT_ADMIN'],
      scopes: [],
      status: USER_STATUS.ACTIVE,
    } as User;
  }
}

export const userFactory = new UserFactory();
